// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { toProjectStatus } from '@/constants/project-status';
import { ProjectFilter } from '@/project/api/get-projects';
import { projectBillingAggregateResponseSchema } from '@/project/api/types';
import queryString from 'query-string';

const PATH = '/v1/project-aggregate/billing';

/**
 * Requests billing aggregates for projects matching the provided filters.
 * Uses the same filter interface as the projects endpoint.
 */
export async function getProjectBillingAggregate(
  filter?: Omit<
    ProjectFilter,
    | 'pageSize'
    | 'pageNumber'
    | 'sort'
    | 'startClassifications'
    | 'endClassifications'
  >
) {
  const response = await api.get(PATH, {
    paramsSerializer: (parameters) => queryString.stringify(parameters),
    params: {
      archived: filter?.isArchived,
      productFulfillmentStatus: filter?.productFulfillmentStatus,
      projectFulfillmentStatus: filter?.projectFulfillmentStatus,
      projectIds: filter?.projectIds,
      statuses: filter?.statuses?.map(toProjectStatus),
      itemIds: filter?.productIds,
      locationIds: filter?.locationIds,
      customerIds: filter?.customerIds,
      workflowStageIds: filter?.workflowStageIds,
      startBy: filter?.startBy,
      endBy: filter?.endBy,
      completeDatesOnly: filter?.completeDatesOnly,
      search: filter?.query,
    },
  });

  return parseResponse(projectBillingAggregateResponseSchema, response.data, {
    schemaName: 'ProjectBillingAggregate',
    endpoint: PATH,
  });
}
